import {
  Redirect,
  Route,
  Switch,
  withRouter,
  useLanguage,
} from "@ipc/ipc-core";
// import { Redirect, Route, Switch, withRouter, useLanguage } from '@ipc/routing';
// import { PrivateRoute } from '@ipc/routing-security';
import React, { useEffect } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { AppContentStyle } from "./AppContent.styles";
import DashboardContainer from "../../modules/dashboard/containers/DashboardContainer";
// import PrivateRoute from './PrivateRoute';
import scDefinitions from "../../modules/common/config/SelectionCriteriaDefinitions";
import SelectionCriteriaWizardContainer from "../../modules/wizard/common/containers/SelectionCriteriaWizardContainer";
import AdminDashboardContainer from "../../modules/admin/dashboard/containers/AdminDashboardContainer";
import ReportContainer from "../../modules/report/common/containers/ReportContainer";
import { setHistory } from "../../core/modules/common/tools/HistoryTools";
import { wizardRoutes } from "../../modules/wizard/common/Routes/WizardRoutes";
import ReportDefinitions, {
  applySelectionCriteriaBasedOnUser,
} from "../../modules/common/config/ReportDefinitions";
import ReportDownloadContainer from "../../modules/report/common/containers/ReportDownloadContainer";
import NotificationsContainer from "../../core/modules/common/containers/NotificationsContainer";
import { getUserType } from "../../modules/user/redux/selectors/UserReportSelectors";

const StyledAppContent = styled.div`
  ${AppContentStyle}
`;

export const AppContent = ({ history, userType }) => {
  const [, language] = useLanguage();
  setHistory(history);
  const { pathname } = history.location;

  useEffect(() => {
    applySelectionCriteriaBasedOnUser(userType);
  }, [userType]);

  return (
    <>
      <NotificationsContainer />
      <Switch>
        <Route
          exact
          path="/"
          component={() => (
            <Redirect to={`/${language("report-definitions")}`} />
          )}
        />
        <Route
          exact
          path={language("/login")}
          component={() => (
            <Redirect to={`/${language("report-definitions")}`} />
          )}
        />
        <Route
          exact
          path={language("/")}
          component={() => (
            <Redirect to={`/${language("report-definitions")}`} />
          )}
        />
        <Route
          exact
          path={language("/report-definitions")}
          component={(props) => <DashboardContainer {...props} />}
        />
        <Route
          exact
          path={language("/admin")}
          component={(props) => <AdminDashboardContainer {...props} />}
        />
        <Route>
          <StyledAppContent>
            <Switch>
              {/* eslint-disable-next-line react/self-closing-comp */}
              <Route
                path={language("/report-wizard/:reportName")}
                exacts
                render={(props) => (
                  <Route>
                    <Route render={() => <SelectionCriteriaWizardContainer {...props} />}>
                      {!pathname.includes("download") &&
                        pathname.slice(pathname.lastIndexOf("/") + 1) !==
                          "report" &&
                        !Object.keys(scDefinitions)
                          .map((sc) => scDefinitions[sc].routePath)
                          .includes(
                            pathname.slice(pathname.lastIndexOf("/") + 1)
                          ) && (
                          <Redirect
                            to={
                              props.match.url.slice(-1) === "/"
                                ? `${props.match.url}period`
                                : `${props.match.url}/period`
                            }
                          />
                        )}
                    </Route>
                    <Route>
                      {Object.keys(scDefinitions).map((sc) => {
                        const isActive =
                          ReportDefinitions[
                            props.match.params.reportName
                          ].selectionCriteria.items.includes(sc) &&
                          pathname.slice(pathname.lastIndexOf("/") + 1) ===
                            scDefinitions[sc].routePath;

                        const wizardChildren = {
                          routes: wizardRoutes(props.match.params.reportName),
                          report:
                            ReportDefinitions[props.match.params.reportName],
                        };

                        return (
                          isActive && (
                            <div
                              key={sc}
                              style={{
                                display: "flex",
                                flex: "1 1 auto",
                                overflowX: "hidden",
                              }}
                            >
                              {React.createElement(
                                scDefinitions[sc].component,
                                props,
                                wizardChildren
                              )}
                            </div>
                          )
                        );
                      })}
                    </Route>
                    <Route
                      path={language(`${props.match.url}/report`)}
                      component={() => <ReportContainer {...props} />}
                    />
                    <Route
                      path={language(
                        "/report-wizard/:reportName/download/:execId"
                      )}
                      render={(routeProps) => (
                        <ReportDownloadContainer
                          key={`${routeProps.match.params.reportName}/${routeProps.match.params.execId}`}
                          {...props}
                          {...routeProps}
                        />
                      )}
                    />
                  </Route>
                )}
              ></Route>
            </Switch>
          </StyledAppContent>
        </Route>

        <Route
          component={() => (
            <Redirect to={`/${language("report-definitions")}`} />
          )}
        />
      </Switch>
    </>
  );
};

const mapStateToProps = (state) => ({
  userType: getUserType(state),
});

export default withRouter(connect(mapStateToProps)(AppContent));
